var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo, useCallback, useState, useRef, useEffect } from 'react';
import { createPrefixCls } from '../_utils/string';
import Icon from '../icon';
import Input from '../input';
const prefixCls = createPrefixCls('search');
export const Search = (_a) => {
    var { className, inputClassName, inputWrapClassName, defaultValue, value, cancelBtn, onCancel, onChange } = _a, restProps = __rest(_a, ["className", "inputClassName", "inputWrapClassName", "defaultValue", "value", "cancelBtn", "onCancel", "onChange"]);
    const [focus, setFocus] = useState(false);
    const [inputValue, setInputValue] = useState(defaultValue);
    const blurTimer = useRef();
    useEffect(() => {
        setInputValue(value);
    }, [value]);
    const handleFocus = useCallback(() => {
        setFocus(true);
        clearTimeout(blurTimer.current);
    }, []);
    const handleBlur = useCallback(() => {
        blurTimer.current = setTimeout(() => {
            setFocus(false);
        }, 100);
    }, []);
    const handleCancel = useCallback(() => {
        if (cancelBtn === 'focus') {
            setInputValue('');
        }
        onCancel && onCancel();
    }, [cancelBtn, onCancel]);
    const handleChange = useCallback((e) => {
        setInputValue(e.target.value);
        onChange && onChange(e);
    }, [onChange]);
    const searchCls = useMemo(() => {
        return classnames([prefixCls(), className]);
    }, [className]);
    return (React.createElement("div", { className: searchCls },
        React.createElement(Icon, { className: prefixCls('search-icon'), name: "search" }),
        React.createElement(Input, Object.assign({ value: inputValue, className: classnames(prefixCls('input'), inputClassName), wrapClassName: classnames(prefixCls('input-wrap'), inputWrapClassName), placeholder: "\u641C\u7D22", allowClear: true, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur }, restProps)),
        cancelBtn && ((focus && cancelBtn === 'focus') || cancelBtn === 'always') && (React.createElement("div", { className: prefixCls('cancel'), onClick: handleCancel }, "\u53D6\u6D88"))));
};
export default Search;
